import { useState } from 'react'
import { BsBank2, BsFillWalletFill } from 'react-icons/bs'
import { FaRegMoneyBillAlt } from 'react-icons/fa'
import { GiMoneyStack } from 'react-icons/gi'
import { HiDotsVertical } from 'react-icons/hi'
import { useDispatch } from 'react-redux'
import { IBank, IUser } from 'safe'
import FloatingMenu from '../../components/Display/FloatingMenu'
import Modal from '../../components/Display/Modal'
import ModalConfirm from '../../components/Display/ModalConfirm'
import ModalViewWithTabs from '../../components/Display/ModalViewWithTabs'
import { DataTabView } from '../../components/Display/ViewWithTabs'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import Restaurant from '../../assets/images/restaurant.svg'

const WaiterCard: React.FC<WaiterCardProps> = ({
  user,
  fromSafeBox = false,
  onPressCardProp = () => null,
  banks = [],
  onEdit,
  onDelete,
  onWatch,
}) => {
  const [modalDescription, setModalDescription] = useState<boolean>(false)
  const [visibleMenu, setVisibleMenu] = useState<boolean>(false)
  const [displayConfirm, setDisplayConfirm] = useState<boolean>(false)
  const [editModal, setEditModal] = useState<boolean>(false)
  const [dataWithTabs, setDataWithTabs] = useState<DataTabView[]>([])

  const { addAlert } = useSnackBars()

  const onPressCard = () => {}

  const dispatch = useDispatch()

  const toggle = (): void => {
    setVisibleMenu((state) => !state)
  }

  const setVisible = async (wantedState: boolean) => {
    try {
      addAlert({
        message: 'Actualizando cuenta...',
        status: 'loading',
      })
      //   await dispatch(setAccountVisible(String(table.id), wantedState))
      addAlert({
        message: 'Visibilidad actualizada con éxito',
        status: 'success',
      })
    } catch (error: any) {
      addAlert({
        message:
          error.response.data.message ||
          'Error al modificar disponibilidad en cuenta',
        status: 'error',
      })
    } finally {
      toggle()
    }
  }

 

  return (
    <>
      <ModalViewWithTabs
        display={modalDescription}
        onClose={() => {
          setModalDescription(false)
        }}
        dataWithTabs={dataWithTabs}
      />

      <div className="2xl:w-96 w-80 shadow-lg rounded-lg p-4 mb-5 mr-5 text-xl flex justify-between relative dark:bg-black m-auto">
        <div
          className="w-80 cursor-pointer"
          onClick={() => onPressCardProp()}
          // style={{ opacity: account.accountVisible ? '1' : '0.4' }}
        >
          <div className="h-8 flex items-center">
            <div className="flex items-center truncate text-primary-600 font-medium">
              <div className="mr-4">
                {/* <FaRegMoneyBillAlt
                  size="0.9rem"
                  className="dark:text-white text-dark"
                /> */}
                <img src={Restaurant} alt="restaurant" className="w-5 h-5" />
              </div>
              <div className="truncate text-sm max-h-10 dark:text-white">
                {user?.realName}
              </div>
            </div>
          </div>

          <div className="flex flex-row">
            <div className="text-sm max-h-10 dark:text-white mr-2">
              Correo:
            </div>
            <div className="text-sm max-h-10 dark:text-white">
              {user?.email}
            </div>
          </div>

          <div className="flex flex-row">
            <div className="text-sm max-h-10 dark:text-white mr-2">
              Estado:
            </div>
            <div className="text-sm max-h-10 dark:text-white">
              {user?.enabled ? 'Habilitado' : 'Inhabilitado'}
            </div>
          </div>
        </div>

        {!fromSafeBox && (
          <FloatingMenu
            onClose={() => {
              setVisibleMenu(false)
            }}
            visible={visibleMenu}
            options={{
              onCustomButtons: [
                {
                  title: 'Ver',
                  action: () => {
                    onWatch && onWatch()
                  },
                  display: true,
                },
              
                {
                  title: 'Editar Mesonero',
                  action: () => onEdit && onEdit(user),
                  display: true,
                },
                {
                  title: 'Eliminar',
                  action: () => setDisplayConfirm(true),
                  display: true,
                },
              ],
            }}
          >
            <HiDotsVertical
              className="cursor-pointer text-gray-400"
              onClick={toggle}
            />
          </FloatingMenu>
        )}
      </div>

      <ModalConfirm
        title={'¿Está seguro que desea eliminar este mesero?'}
        displayConfirmModal={displayConfirm}
        onConfirm={() => onDelete && onDelete(user.idNevulaUser)}
        onCancel={() => setDisplayConfirm(false)}
      ></ModalConfirm>
    </>
  )
}

interface WaiterCardProps {
  user: IUser
  fromSafeBox?: boolean
  onPressCardProp?: Function
  onEdit?: Function
  banks?: IBank[]
  onDelete?: Function
  onWatch?: Function
}

export default WaiterCard
